import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Title } from 'react-native-paper';
import { pixelDimensions } from '../../config/utils';
import { appColors } from '../../assets/styles/global';
import { AppText } from '../form';

export default function PriceBlock({
  price, perHour,
}) {
  return (
    <View style={styles.baseView}>
      <Title style={styles.textValue}>
        {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price)}
      </Title>
      {perHour && (
      <AppText style={styles.text}>Mensal</AppText>

      )}
    </View>
  );
}

const styles = StyleSheet.create({
  baseView: {
    padding: pixelDimensions(2),
    borderRadius: 8,
    alignSelf: 'center',
    backgroundColor: appColors.primary,
  },
  textValue: {
    color: appColors.white,
    fontWeight: 'bold',
    fontSize: pixelDimensions(5.2),

  },
  text: {
    alignSelf: 'center',
    color: appColors.white,
    fontWeight: 'bold',
  },
});
